/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 10:50:00 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  Datagrid,
  List,
  TextField,
  NumberField,
  useTranslate,
  Title,
} from 'react-admin';
import { EmptyResource } from 'Layout';
import ListFilter from './filter';
import ListActions from './actions';
import { PostPagination } from '../../Components/CustomPagination/pagination';

function EmptyOrganisations(props) {
  return (
    <EmptyResource
      title={'resources.Organisation.emptyStateTitle'}
      subtitle={'resources.Organisation.emptyStateSubtitle'}
      buttonLabel={'createOrganisation'}
      basePath={props.basePath}
    />
  );
}

const OrganisationList = props => {
  const translate = useTranslate();

  return (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <List
        title={translate('resources.Organisation.name', { smart_count: 2 })}
        bulkActionButtons={false}
        perPage={25}
        pagination={<PostPagination />}
        exporter={false}
        actions={<ListActions />}
        filters={<ListFilter />}
        empty={<EmptyOrganisations {...props} />}
        {...props}
      >
        <Datagrid rowClick="edit">
          <TextField
            source="name"
            label="resources.Organisation.fields.organisation"
            sortable={false}
          />
          <NumberField
            source="statistics.numberOfProjects"
            label={'resources.Organisation.fields.numberOfProjects'}
            sortable={false}
          />
          <NumberField
            source="statistics.numberOfSites"
            label={'resources.Organisation.fields.numberOfSites'}
            sortable={false}
          />
          <NumberField
            source="statistics.numberOfUsers"
            label={'resources.Organisation.fields.numberOfUsers'}
            sortable={false}
          />
        </Datagrid>
      </List>
    </>
  );
};
export default OrganisationList;
